import { Wrapper, Search, Separator, Total, Showing, DefaultActions } from '@/components/Grid/components/header/Heading';
import { GridProvider, DefaultGrid, useBuildGrid } from '@Components/Grid';

import { useDatasourceStore } from '../../store';

import useColumns from './useColumns'
import useDefinitions from './useDefinitions'
import useEvents from './useEvents'
import useFilters from './useFilters'

function DatasourceGrid() {
  useBuildGrid({
    definitions: useDefinitions(),
    columns: useColumns(),
    filters: useFilters(),
    events: useEvents(),
  })

  return <DefaultGrid
    heading={<Wrapper>
      <Search />
      <Separator />
      <Total />
      <Showing />
      <Separator />
      <DefaultActions />
    </Wrapper>}
  />
}

export default function DatasourceGridLayout() {
  return <GridProvider store={useDatasourceStore()}>
    <DatasourceGrid />
  </GridProvider>
}
